export default "__VITE_ASSET__BEgEjI7u__"